import { Facebook, Instagram, Youtube } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);
const TelegramIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

const PLATFORMS = [
  { key: "social_facebook", label: "Facebook", Icon: Facebook },
  { key: "social_instagram", label: "Instagram", Icon: Instagram },
  { key: "social_youtube", label: "YouTube", Icon: Youtube },
  { key: "social_twitter", label: "X", Icon: XIcon },
  { key: "social_tiktok", label: "TikTok", Icon: TikTokIcon },
  { key: "social_telegram", label: "Telegram", Icon: TelegramIcon },
];

export default function SocialLinks({ variant = "footer", className = "" }) {
  const settings = useSettings();
  const links = PLATFORMS.filter((p) => (settings[p.key] || "").trim());
  if (links.length === 0) return null;

  const dark = variant === "footer";
  const linkClass = dark
    ? "text-slate-400 ring-slate-700 hover:bg-white/10 hover:text-white"
    : "text-slate-500 ring-slate-200 hover:bg-primary/10 hover:text-primary";

  const row = (
    <div
      className={`flex flex-wrap items-center gap-2 ${variant === "block" ? "mt-4" : className}`}
      data-testid="social-links"
    >
      {links.map(({ key, label, Icon }) => (
        <a
          key={key}
          href={settings[key]}
          target="_blank"
          rel="noreferrer noopener"
          aria-label={label}
          title={label}
          data-testid={`social-${label.toLowerCase()}`}
          className={`flex h-10 w-10 items-center justify-center rounded-full ring-1 ring-inset transition-colors duration-200 ${linkClass}`}
        >
          <Icon className="h-[18px] w-[18px]" />
        </a>
      ))}
    </div>
  );

  if (variant === "block") {
    return (
      <div className={`rounded-xl border border-slate-200 bg-white p-5 ${className}`} data-testid="follow-us-box">
        <h3 className="font-display text-base font-bold text-slate-900">Последвайте ни</h3>
        <p className="mt-1 text-sm text-slate-500">Новините на Подуяне и в социалните мрежи.</p>
        {row}
      </div>
    );
  }
  return row;
}
